import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/client/components/Navbar.tsx");
